(function () {

    "use strict";
    angular
        .module('harriApp')
        .directive('hSlider', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'AE',
                scope: {
                    initOnload: '@',
                    currentIndex: '=',
                    accessibility: '@',
                    adaptiveHeight: '@',
                    arrows: '@',
                    asNavFor: '@',
                    appendArrows: '@',
                    appendDots: '@',
                    autoplay: '@',
                    autoplaySpeed: '@',
                    centerMode: '@',
                    centerPadding: '@',
                    cssEase: '@',
                    customPaging: '&',
                    dots: '@',
                    draggable: '@',
                    easing: '@',
                    fade: '@',
                    focusOnSelect: '@',
                    infinite: '@',
                    initialSlide: '@',
                    lazyLoad: '@',
                    onBeforeChange: '&',
                    onAfterChange: '&',
                    onInit: '&',
                    onReInit: '&',
                    onSetPosition: '&',
                    pauseOnHover: '@',
                    pauseOnDotsHover: '@',
                    responsive: '=',
                    rtl: '@',
                    slide: '@',
                    slidesToShow: '@',
                    slidesToScroll: '@',
                    speed: '@',
                    swipe: '@',
                    swipeToSlide: '@',
                    touchMove: '@',
                    touchThreshold: '@',
                    useCSS: '@',
                    variableWidth: '@',
                    vertical: '@',
                    prevArrow: '@',
                    nextArrow: '@',
                    prevArrowAsSelector: '@',
                    nextArrowAsSelector: '@',
                    verticalSwiping: '@',
                    index: '=',
                    onChange: '&'
                },
                link: function (scope, element, attrs) {
                    var slider;

                    var destroy = function () {
                        $timeout(function () {
                            slider.off('afterChange');
                            slider.slick('unslick');
                            slider.find('.slick-list').remove();
                            slider = null;
                        });
                    };

                    var init = function () {
                        $timeout(function () {
                            slider = $(element);

                            slider.slick({
                                accessibility: scope.accessibility !== 'false',
                                adaptiveHeight: scope.adaptiveHeight === 'true',
                                arrows: scope.arrows !== 'false',
                                asNavFor: scope.asNavFor,
                                appendArrows: scope.appendArrows,
                                appendDots: scope.appendDots,
                                autoplay: scope.autoplay === 'true',
                                autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
                                centerMode: scope.centerMode === 'true',
                                centerPadding: scope.centerPadding || '50px',
                                cssEase: scope.cssEase || 'ease',
                                customPaging: attrs.customPaging,
                                dots: scope.dots === 'true',
                                draggable: scope.draggable !== 'false',
                                easing: scope.easing || 'linear',
                                fade: scope.fade === 'true',
                                focusOnSelect: scope.focusOnSelect === 'true',
                                infinite: scope.infinite !== 'false',
                                initialSlide: scope.initialSlide || 0,
                                lazyLoad: scope.lazyLoad || 'ondemand',
                                beforeChange: attrs.onBeforeChange,
                                onReInit: attrs.onReInit,
                                onSetPosition: attrs.onSetPosition,
                                pauseOnHover: scope.pauseOnHover !== 'false',
                                responsive: scope.responsive,
                                rtl: scope.rtl === 'true',
                                slide: scope.slide || 'div',
                                slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
                                slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
                                speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
                                swipe: scope.swipe !== 'false',
                                swipeToSlide: scope.swipeToSlide === 'true',
                                touchMove: scope.touchMove !== 'false',
                                touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
                                useCSS: scope.useCSS !== 'false',
                                variableWidth: scope.variableWidth === 'true',
                                vertical: scope.vertical === 'true',
                                prevArrow: scope.prevArrowAsSelector ? $(scope.prevArrowAsSelector) : scope.prevArrow,
                                nextArrow: scope.nextArrowAsSelector ? $(scope.nextArrowAsSelector) : scope.nextArrow,
                            });

                            slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
                                scope.index = currentSlide;
                                scope.onChange({index: currentSlide, nextIndex: nextSlide, event: event});
                                scope.$apply();
                            });
                        });
                    };

                    init();

                    scope.$on('$destroy', function () {
                        destroy();
                    });
                }
            };
        }
    ]);

})();
